var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "174px",
    height: "91px",
    viewBox: "0 0 174 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D9209D7A-04A5-4C5E-A447-80562A67DCF0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-650.000000, -399.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(568.000000, 290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(38.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NoImages",
    transform: "translate(31.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.2,107.2 L50.4,107.2 C47.3072054,107.2 44.8,104.692795 44.8,101.6 C44.8,98.5072054 47.3072054,96 50.4,96 L19.2,96 C16.1072054,96 13.6,93.4927946 13.6,90.4 C13.6,87.3072054 16.1072054,84.8 19.2,84.8 L51.2,84.8 C54.2927946,84.8 56.8,82.2927946 56.8,79.2 C56.8,76.1072054 54.2927946,73.6 51.2,73.6 L31.2,73.6 C28.1072054,73.6 25.6,71.0927946 25.6,68 C25.6,64.9072054 28.1072054,62.4 31.2,62.4 L63.2,62.4 C60.1072054,62.4 57.6,59.8927946 57.6,56.8 C57.6,53.7072054 60.1072054,51.2 63.2,51.2 L108.8,51.2 C111.892795,51.2 114.4,53.7072054 114.4,56.8 C114.4,59.8927946 111.892795,62.4 108.8,62.4 L160,62.4 C163.092795,62.4 165.6,64.9072054 165.6,68 C165.6,71.0927946 163.092795,73.6 160,73.6 L177.6,73.6 C180.692795,73.6 183.2,76.1072054 183.2,79.2 C183.2,82.2927946 180.692795,84.8 177.6,84.8 L162.4,84.8 C159.307205,84.8 156.8,87.3072054 156.8,90.4 C156.8,93.4927946 159.307205,96 162.4,96 L167.2,96 C170.292795,96 172.8,98.5072054 172.8,101.6 C172.8,104.692795 170.292795,107.2 167.2,107.2 L125.6,107.2 C125.1881,107.2 124.786587,107.15553 124.4,107.071128 C124.013413,107.15553 123.6119,107.2 123.2,107.2 Z M180.8,107.2 C177.707205,107.2 175.2,104.692795 175.2,101.6 C175.2,98.5072054 177.707205,96 180.8,96 C183.892795,96 186.4,98.5072054 186.4,101.6 C186.4,104.692795 183.892795,107.2 180.8,107.2 Z",
    id: "Background",
    fillOpacity: 0.232817963,
    fill: "#50E3C2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Photo2",
    strokeWidth: 1,
    transform: "translate(52.786020, 32.789650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.6860887,4.51101019 L70.9742024,4.51101019 C72.7415136,4.51101019 74.1742024,5.94369899 74.1742024,7.71101019 L74.1742024,71.7110102 C74.1742024,73.4783214 72.7415136,74.9110102 70.9742024,74.9110102 L7.77420237,74.9110102 C6.00689117,74.9110102 4.57420237,73.4783214 4.57420237,71.7110102 C4.57420237,68.9829258 4.57420237,67.1496814 4.57420237,66.2112771",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(39.374202, 39.711010) rotate(-188.000000) translate(-39.374202, -39.711010) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2581019,74.9802698 L15.3014007,75.4005137 C13.7122187,75.6263884 12.2449327,74.5214229 12.0241258,72.9325042 L4.02799853,15.3926677 C3.80719157,13.803749 4.91647874,12.3325682 6.50566076,12.1066935 L63.3356655,4.0292919 C64.9248475,3.80341718 66.3921335,4.90838266 66.6129405,6.49730137 L67.3000743,11.4418911 C67.3372552,11.7094436 69.7920902,29.4689997 74.6645794,64.7205594 C74.9092511,66.4906797 73.6886977,68.1262347 71.9384017,68.373673 C71.9196015,68.3763308 71.9007784,68.3788193 71.8819344,68.3811383 L18.2581019,74.9802698 Z",
    id: "Rectangle",
    fill: "#E8F0FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6860887,4.51101019 L70.9742024,4.51101019 C72.7415136,4.51101019 74.1742024,5.94369899 74.1742024,7.71101019 L74.1742024,71.7110102 C74.1742024,73.4783214 72.7415136,74.9110102 70.9742024,74.9110102 L7.77420237,74.9110102 C6.00689117,74.9110102 4.57420237,73.4783214 4.57420237,71.7110102 C4.57420237,68.9829258 4.57420237,67.1496814 4.57420237,66.2112771",
    id: "Rectangle",
    stroke: "#2D4EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(39.374202, 39.711010) rotate(-188.000000) translate(-39.374202, -39.711010) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8139804,12.3140265 L71.2139804,14.8103503",
    id: "Line",
    stroke: "#2D4EF5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Photo1",
    strokeWidth: 1,
    transform: "translate(71.327344, 44.548438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2,5 C5.98497355,5 5,5.98497355 5,7.2 L5,71.2 C5,72.4150264 5.98497355,73.4 7.2,73.4 L70.4,73.4 C71.6150264,73.4 72.6,72.4150264 72.6,71.2 L72.6,7.2 C72.6,5.98497355 71.6150264,5 70.4,5 L7.2,5 Z",
    id: "Rectangle",
    stroke: "#2D4EF5",
    strokeWidth: 2,
    fill: "#FFFFFF",
    transform: "translate(38.800000, 39.200000) rotate(6.000000) translate(-38.800000, -39.200000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0599252,11.2241037 L64.4599252,11.2241037 C65.7854086,11.2241037 66.8599252,12.2986203 66.8599252,13.6241037 L66.8599252,56.0241037 C66.8599252,57.3495871 65.7854086,58.4241037 64.4599252,58.4241037 L14.0599252,58.4241037 C12.7344418,58.4241037 11.6599252,57.3495871 11.6599252,56.0241037 L11.6599252,13.6241037 C11.6599252,12.2986203 12.7344418,11.2241037 14.0599252,11.2241037 Z",
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(39.259925, 34.824104) rotate(6.000000) translate(-39.259925, -34.824104) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6126465,45.6375018 L23.8550858,39.560759 C25.0627002,38.5475145 26.828343,38.564676 28.0160342,39.6012022 L34.3693192,45.1458639 C34.6864108,45.4225972 35.163694,45.4063249 35.4612016,45.1086376 L46.6264406,33.9366522 C47.8757408,32.6865971 49.9018686,32.6859851 51.1519238,33.9352854 C51.2327033,34.0160161 51.3091032,34.1010135 51.3807953,34.1899125 L60.6126465,45.6375018 L61.9530763,47.4206845 L62.0863806,53.9422764 C62.0954099,54.3840119 61.7446321,54.749429 61.3028966,54.7584583 C61.2958664,54.758602 61.2888347,54.758653 61.2818032,54.7586113 L15.4320433,54.4866893 C14.9960943,54.4841038 14.6424772,54.132942 14.6368543,53.6970216 L14.5519008,47.1109146 L16.6126465,45.6375018 Z",
    id: "Path-2",
    fill: "#E8F0FE",
    transform: "translate(38.327534, 43.090235) rotate(6.000000) translate(-38.327534, -43.090235) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0599252,12.2241037 C13.2867266,12.2241037 12.6599252,12.850905 12.6599252,13.6241037 L12.6599252,56.0241037 C12.6599252,56.7973023 13.2867266,57.4241037 14.0599252,57.4241037 L64.4599252,57.4241037 C65.2331239,57.4241037 65.8599252,56.7973023 65.8599252,56.0241037 L65.8599252,13.6241037 C65.8599252,12.850905 65.2331239,12.2241037 64.4599252,12.2241037 L14.0599252,12.2241037 Z",
    id: "Rectangle",
    stroke: "#2D4EF5",
    strokeWidth: 2,
    transform: "translate(39.259925, 34.824104) rotate(6.000000) translate(-39.259925, -34.824104) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#2D4EF5",
    strokeWidth: 2,
    fill: "#E8F0FE",
    transform: "translate(26.298281, 24.211104) rotate(6.000000) translate(-26.298281, -24.211104) ",
    cx: 26.2982806,
    cy: 24.2111037,
    r: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4520094,47.0601043 C17.3883712,45.3988072 20.2929138,42.9068616 24.1656374,39.5842674 C25.3732517,38.5710229 27.1388946,38.5881845 28.3265858,39.6247106 L34.6798708,45.1693723 C34.9969624,45.4461056 35.4742456,45.4298333 35.7717531,45.132146 L46.9369921,33.9601606 C48.1862924,32.7101055 50.2124202,32.7094935 51.4624753,33.9587938 C51.5432549,34.0395246 51.6196548,34.1245219 51.6913469,34.2134209 C57.2416456,41.261602 60.6652554,45.6091558 61.9621765,47.2560824",
    id: "Path-2",
    stroke: "#2D4EF5",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(38.707093, 40.139151) rotate(6.000000) translate(-38.707093, -40.139151) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateDashboard);
export default __webpack_public_path__ + "static/media/EmptyState-dashboard.8d2cd3773186010897fbf63920d47927.svg";
export { ForwardRef as ReactComponent };